import { render } from "./pop-up.vue?vue&type=template&id=07101eae&scoped=true"
import script from "./pop-up.vue?vue&type=script&lang=js"
export * from "./pop-up.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-07101eae"

export default script